'use client';

import { memo, useMemo } from 'react';
import RenderDate from './components/progress-render-date/ProgressRenderDate';
import RenderLink from './components/progress-render-link/ProgressRenderLink';
import { months } from './constants';
import style from './ProgressSlide.module.scss';

const ProgressSlide = memo(({ isMobile, item, common = false, arrLength, general = false }) => {
  const date = new Date(item?.title);

  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const month = months[date.getUTCMonth()];

  const classNameImg = useMemo(() => {
    if (common) {
      return `${style.card__img_common}`;
    }

    return `${style.card__img} progress_slide_img`;
  }, [common]);

  const changedStageSpelling = useMemo(() => {
    const stageSpelling = ['I', 'II', 'III'];

    return stageSpelling[item?.number_stage - 1];
  }, [item?.number_stage]);

  const imgStyle = useMemo(() => {
    let calcResult = 1.25;

    if (arrLength > 5 && arrLength < 10) calcResult = (125 + 5 * (arrLength - 5)) / 100;

    if (arrLength >= 10) calcResult = (125 + 5 * (10 - 5)) / 100;

    return { transform: `translate(2.5%, 0%) scale(${calcResult})` };
  }, []);

  return (
    <>
      <div className={general ? style.generalWrapper : style.wrapper}>
        {general && !isMobile && <p className={style.generalStage}>{changedStageSpelling} очередь</p>}
        <RenderLink
          item={item}
          imgCount={item?.imagesCount}
          imgPreview={item?.imgPreview}
          general={general}
          videoCount={item?.videosCount}
          imgStyle={imgStyle}
          classNameImg={classNameImg}
        />
        {(!general || isMobile) && (
          <p className={general ? style.generalStage : style.paragraph}>{changedStageSpelling} очередь</p>
        )}
        <RenderDate general={general} day={day} month={month} year={year} isMobile={isMobile} />
      </div>
    </>
  );
});

export default ProgressSlide;
